var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"p-l-20 p-t-10"},[_vm._v("站点投放量top20")]),_c('div',{staticStyle:{"width":"100%","height":"250px"},attrs:{"id":"ownerStationChartReport"}})])
}]

export { render, staticRenderFns }